module.exports = __webpack_public_path__ + "img/19-bg.770be0a8.jpg";